<template>
  <div style="support">
    <h4 class="title is-4">機器トラブル時の初期対応</h4>
    <p>正常に動作しないと思われる場合、以下のご確認をお願い致します。<br /></p>
    <hr />
    <h5 class="title is-5">カメラユニット</h5>
    <ul class="description">
      <li>本体の電源スイッチが「ON」になっていることを確認してください。</li>
      <li>
        動画モードになっていることを確認してください（※モード確認方法参照）
      </li>
      <li>電波状態が良いことを確認してください（※アンテナ強度確認方法参照）</li>
      <li>Pescle WebシステムのDevice Configへの登録が正しいことを確認</li>
      <ul class="description">
        <li>『Trail Camera』が選択されていることを確認してください。</li>
        <li>シリアル番号が正しいことを確認してください。</li>
      </ul>
      <li>電池全てを新品に交換して確認してください。</li>
    </ul>
    <hr />
    <h5 class="title is-5">撮影モード確認方法</h5>
    <p>
      トレイルカメラには動画モードと静止画モードの2つのモードがあります。<br />
      PESCLEでは動画使い、害獣の判断を行います。動画モードになっているか設定を確認してください。
    </p>
    <div class="columns mt-4">
      <div class="column is-one-quarter">
        <img src="/img/trailcam.png" class="image" />
      </div>
      <div class="column">
        <table class="table">
          <thead>
            <tr>
              <th width="20%" class="has-text-centered">番号</th>
              <th>説明</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="has-text-centered is-vcentered">1</td>
              <td>
                機器中央の電源スイッチを「SETUP」します。
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">2</td>
              <td>
                SETUP画面にした状態で、<span class="check"
                  >アイコンが動画モード(<i class="fas fa-video"></i
                  >ビデオマーク)</span
                >になっている事を確認下さい。静止画モードの場合は
                <i class="fas fa-camera"></i>
                カメラマークになっています。
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">※</td>
              <td>
                SETUP画面時に、
                <span class="check">▲と▼を押すとモードが切り替わって</span
                >しましますので、押さないように注意してください。
                モードが切り替わった場合は▲と▼を押してモードを切り替えてください。
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />
    <h5 class="title is-5">アンテナ強度確認方法</h5>
    <p>
      トレイルカメラの通信には携帯電話回線（NTT docomo系統網）を利用します。<br />
      通信が取れない場合は電波状況の確認をお願い致します。
    </p>
    <div class="columns mt-4">
      <div class="column is-one-quarter">
        <img src="/img/trailcam2.png" class="image" />
      </div>
      <div class="column">
        <table class="table">
          <thead>
            <tr>
              <th width="20%" class="has-text-centered">番号</th>
              <th>説明</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="has-text-centered is-vcentered">1</td>
              <td>
                機器中央の電源スイッチを「SETUP」します。
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">2</td>
              <td>
                SETUP画面にした状態で、▲▼を押して、静止画モードに切り替えてください。
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">3</td>
              <td>
                静止画モード（カメラマーク）になっている場合のみ、アンテナマークが表示されます。
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="notification is-danger is-light">
      PESCLEを正しくお使いになるには、トレイルカメラの設定は動画モードにする必要があります。<br />
      アンテナ強度確認後は、必ず動画モードに戻してご利用ください。
    </div>
    <div v-if="plan == 'standard'">
      <h4 class="title is-4">不具合品のご返却</h4>
      <p>
        初期チェックの結果、正常に動作しない事をご確認頂きましたら、弊社までご連絡の上、ご返却をお願い致します。
      </p>
      <div class="card mt-4">
        <div class="card-content">
          <div class="content">
            <p>
              連絡・送付先）<br />
              〒170-0013 東京都豊島区東池袋3-3-5<br />
              サンシャインシティ アネックスビル 12F<br />
              株式会社RYODEN<br />
              新事業推進室 事業開発部<br />
              担当：西川 榎本 池田<br />
            </p>
            <p>
              Email:pescle@mgw.ryoden.co.jp
            </p>
            <p>
              TEL:03-5396-6140<br />
              (受付時間:弊社営業日9:00～12:00、13:00～17:30)
            </p>
          </div>
        </div>
      </div>
      <p>
        弊社にて不具合が確認出来ましたら、該当するユニットを弊社までご返却をお願い致します。<br />
        返却品到着後３営業日以内に代替品ユニットを発送させて頂きます。<br />
      </p>
    </div>

    <hr />
  </div>
</template>

<script>
export default {
  props: {
    plan: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
.support {
  margin-bottom: 64px;
}
.description {
  margin: 0 0 0 1em;
  list-style-type: circle;
}

.check {
  font-weight: bold;
  color: red;
}

.image {
  width: 200px;
}
</style>
